/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchDisputeDetails = (values) => {
  return { type: 'DISPUTE_DETAILS', payload: values };
};

export const clearAssignDetlReduxStore = (values) => {
  return { type: 'CLEAR_REDUX_ASS_DTL' };
};

export const assignAllToDefaultUpdate = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.ASSIGN_TO_ALL_DEFAULT}`, values)
    .then((response) => {
      dispatch({ type: 'ASSIGN_ALL_TO_DEFAULT', payload: response.data });
    })
    .catch((response) => response);
};

export const getFromMailId = (logInUser) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_FROM_MAIL_ID}`, { userId: logInUser })
    .then((response) => {
      dispatch({ type: 'FROM_MAIL', payload: response.data.fromMailId });
    })
    .catch((response) => dispatch({ type: 'FROM_MAIL', payload: null }));
};

export const updateFromMailId = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.UPDATE_FROM_MAIL_ID}`, value)
    .then((response) => response.data)
    .catch((response) => response);
};

export const updateToMailId = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.UPDATE_TO_MAIL_ID}`, value)
    .then((response) => response.data)
    .catch((response) => response);
};

export const printDisputeLetter = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.PRINT_DISPUTE_LETTER}`, value, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => response.data)
    .catch((response) => response);
};

export const emailDisputeLetter = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.EMAIL_DISPUTE_LETTER}`, value)
    .then((response) => response.data)
    .catch((response) => response);
};
